import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const ItemDialog = ({ open, onClose, member, approve, deny }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!member) return null;

  const handleApprove = () => {
    if (approve) {
      approve(member); // Pass member to approve function
    }
    onClose(); // Close the dialog
  };

  const handleDeny = () => {
    if (deny) {
      deny(member); // Pass member to deny function
    }
    onClose(); // Close the dialog
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: isMobile ? '10px' : '20px',
          padding: isMobile ? '10px' : '20px',
        },
      }}
    >
      <DialogTitle>
        <Typography variant={isMobile ? "subtitle1" : "h6"} style={{ fontWeight: 'bold' }}>Member Details</Typography>
        <IconButton onClick={onClose} aria-label="Close dialog" style={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {member && member.photoURL && (
          <Box mb={isMobile ? 2 : 3}>
            <Paper elevation={3} style={{ padding: '10px', borderRadius: '10px' }}>
              <img
                src={member.photoURL}
                alt={member.firstName + ' ' + member.surname}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '5px',
                  objectFit: 'contain',
                  maxHeight: isMobile ? '200px' : '300px',
                }}
              />
            </Paper>
          </Box>
        )}
  
        {member ? (
          <Box>
            <Typography variant={isMobile ? "subtitle1" : "h6"} style={{ fontWeight: 'bold', marginBottom: isMobile ? '5px' : '10px' }}>
              {member.firstName} {member.surname}
            </Typography>
            
            <Divider style={{ marginBottom: isMobile ? '10px' : '15px' }} />
  
            {/* Personal Details */}
            <Box mb={3}>
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px', marginTop:'30px' }}>Personal Details</Typography>
              <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
              <Grid container spacing={2}>
                <Grid item xs={6}><Typography><strong>Member ID:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.id}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Salutation:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.salutation}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>First Name:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.firstName}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Surname:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.surname}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Gender:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.gender}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Mobile No:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.mobileNo}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Date of Birth(yyyy-mm-dd):</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.dob}</Typography></Grid>
              </Grid>
              
            </Box>
  
            {/* Contact Details */}
            <Box mb={3}>
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px', marginTop:'50px' }}>Contact Details</Typography>
              <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
              <Grid container spacing={2}>
                <Grid item xs={6}><Typography><strong>Professional Email:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.professionalEmail}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Personal Email:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.personalEmail}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Alternate Contact No:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.alternateContactNo}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Residing Address:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.resiAddress1} {member.resiAddress2}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>City:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.city}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Pincode:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.pincode}</Typography></Grid>
              </Grid>
            </Box>

            <Box mb={3}>
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px', marginTop:'50px' }}>Membership Details</Typography>
              <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
              <Grid container spacing={2}>
                <Grid item xs={6}><Typography><strong>Membership Category:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.membershipCategory}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Fees Payment Details:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.paymentRef}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Last Payment Date:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.lastPaymentDate}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Payment Amount:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.paymentAmount}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Payment Type:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.paymentType}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Membership Start Date(yyyy-mm-dd):</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.membershipStartDate}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Membership End Date(yyyy-mm-dd):</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.membershipEndDate}</Typography></Grid>
              </Grid>
            </Box>
  
            {/* Professional Details */}
            <Box mb={3}>
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px', marginTop:'50px' }}>Professional Details</Typography>
              <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
              <Grid container spacing={2}>
                <Grid item xs={6}><Typography><strong>Organisation:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.organisation}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Designation:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.designation}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Experience:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.experience}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Area of Expertise:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.expertise}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Qualification:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.qualification}</Typography></Grid>
              </Grid>
            </Box>
  
            {/* Other Details */}
            <Box mb={3}>
              <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px', marginTop:'50px' }}>Other Details</Typography>
              <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
              <Grid container spacing={2}>
                <Grid item xs={6}><Typography><strong>LinkedIn:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.linkedIn}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Facebook:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.facebook}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Instagram:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.instagram}</Typography></Grid>
  
                <Grid item xs={6}><Typography><strong>Referral Source:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.referralSource}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Remarks:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.additionalComments}</Typography></Grid>

                <Grid item xs={6}><Typography><strong>Purpose of Joining:</strong></Typography></Grid>
                <Grid item xs={6}><Typography>{member.purposeOfJoining}</Typography></Grid>
              </Grid>

          </Box>
          </Box>
        ) : (
          <Typography variant={isMobile ? "body2" : "body1"}>Member Details unavailable</Typography>
        )}
      </DialogContent>
      {member && (
        <DialogActions style={{ justifyContent: 'center', padding: isMobile ? '10px 0' : '20px 0' }}>
            <IconButton
          onClick={handleApprove} // Pass member to approve function
          variant="outlined"
          color="primary"
          size="small"
          style={{ borderRadius: '50%', width: isMobile ? 30 : 40, height: isMobile ? 30 : 40, padding: 8, margin: '0 10px' }}
        >
          <Typography variant={isMobile ? "body2" : "body1"}>Approve</Typography>
        </IconButton>

        <IconButton
          onClick={handleDeny} // Pass member to deny function
          variant="outlined"
          color="secondary"
          size="small"
          style={{ borderRadius: '50%', width: isMobile ? 30 : 40, height: isMobile ? 30 : 40, padding: 8, margin: '0 10px' }}
        >
          <Typography variant={isMobile ? "body2" : "body1"}>Deny</Typography>
        </IconButton>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ItemDialog;
